module.exports = __webpack_public_path__ + "img/bess_cap_total.0de70b26.svg";